import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TColumnMappingsSliceState, TColumnMappings, COLUMN_MAPPINGS } from '../types/downloadTypes';
import { RootState } from '../../../core/store';

const initialState: TColumnMappingsSliceState = {
    columnMappingsData: null,
    columnMappingsLoading: false,
    columnMappingsError: null,
};

const columnMappingsSlice = createSlice({
    name: COLUMN_MAPPINGS,
    initialState,
    reducers: {
        getColumnMappingsRequestAction: (state: TColumnMappingsSliceState, _: PayloadAction) => {
            state.columnMappingsLoading = true;
            state.columnMappingsError = null;
            state.columnMappingsData = null;
        },
        getColumnMappingsSuccessAction: (state: TColumnMappingsSliceState, { payload: data }: PayloadAction<TColumnMappings[]>) => {
            state.columnMappingsLoading = false;
            state.columnMappingsData = data;
            state.columnMappingsError = null;
        },
        getColumnMappingsErrorAction: (state: TColumnMappingsSliceState, { payload: error }: PayloadAction<any>) => {
            state.columnMappingsLoading = false;
            state.columnMappingsData = null;
            state.columnMappingsError = {
                message: (error.response && error.response.data) || error.message || '',
                name: error.name,
                stack: error.stack,
            };
        }
    },
});

export const columnMappingsActions = {
    ...columnMappingsSlice.actions
};

export default columnMappingsSlice.reducer;

export const selectColumnMappings = (state: RootState) => state.columnMappingsSlice.columnMappingsData;
export const selectColumnMappingsLoading = (state: RootState) => state.columnMappingsSlice.columnMappingsLoading;
export const selectColumnMappingsError = (state: RootState) => state.columnMappingsSlice.columnMappingsError;